import { SelectOptions } from 'components/commonType';

export type ECSegment = {
  id: string;
  name: string;
  type: ECSegmentType;
  durationDays: number;
  advertiserId: number;
  inclusion: string[];
  vendorNumber?: string;
  eventType?: EventType;
};

export type ECSegmentListDTO = {
  id: string;
  name: string;
  type: ECSegmentType;
  visitors: number;
  status: ECSegmentStatus;
  lastUpdatedTime: string;
  createdTime: string;
  advertiserId: number;
  advertiserName: string;
  expiredTime: string;
};

export type ECSegmentFormData = Omit<ECSegment, 'id'>;

export enum ECSegmentType {
  SEARCH_KEYWORDS = 'SEARCH_KEYWORDS',
  PRODUCT_CATEGORY = 'CATEGORY',
  PRODUCT = 'PRODUCT',
  INTERSECT = 'INTERSECT'
}

export enum ECSegmentStatus {
  ACTIVE = 1,
  UNBOUND = 2,
  PENDING = 3,
  ARCHIVED = 4,
  UPDATING = 5,
  OVERLY_RESTRICTIVE = 6,
  DELETED = 99
}

export const MAX_SEGMENT_LIFETIME = 180;
export const FINAL_STATUS = [
  ECSegmentStatus.ARCHIVED,
  ECSegmentStatus.DELETED
];

export enum EventType {
  SEARCH = 'search',
  VIEW_CONTENT = 'viewContent',
  ADD_TO_CART = 'addToCart',
  PURCHASE = 'purchase'
}

export type ECSegmentRulesDetail = {
  segmentId: string;
  rules: ECSegmentRule[];
};

export type ECSegmentRule = {
  type: ECSegmentType;
  durationDays: number;
  vendorNumber: string;
  eventType: EventType;
  inclusion: string[];
};

export const ALL_VENDOR_OPTION: SelectOptions = { label: 'ALL', value: 'all' };

export const MAX_EC_SEGMENTS_OF_ADVERTISER = 10;
